import axios from "axios";
import { RoleCapability, RoleMatrix } from "../type";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

export const roleService = {
  /**
   * GET /roles/capabilities
   * ดึงรายการ capability ทั้งหมดที่ระบบรองรับ
   */
  getCapabilities: async () => {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API_BASE_URL}/roles/capabilities`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data as {
      data: RoleCapability[];
    };
  },

  /**
   * GET /roles/:orgId
   * ดึง role permission matrix ของ organization หนึ่ง
   */
  getRoleMatrix: async (orgId: string) => {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API_BASE_URL}/roles/${orgId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data as {
      data: boolean;
      orgId: string;
      permissions: RoleMatrix;
    };
  },

  /**
   * PUT /roles/:orgId
   * อัปเดต role permission matrix ของ organization หนึ่ง
   */
  updateRoleMatrix: async (orgId: string, permissions: RoleMatrix) => {
    const token = localStorage.getItem("token");

    const response = await axios.put(
      `${API_BASE_URL}/roles/${orgId}`,
      { permissions },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data as {
      message: string;
      orgId: string;
      permissions: RoleMatrix;
    };
  },

  /**
   * GET /roles/me/effective
   * (optional) ดึง effective permissions ของ user ปัจจุบันใน org ของตัวเอง
   * ใช้ทำ feature flag ฝั่ง frontend ได้ เช่น ซ่อนปุ่มที่ไม่มีสิทธิ์ใช้
   */
  getMyEffectivePermissions: async () => {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API_BASE_URL}/roles/me/effective`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log(response.data)

    return response.data as {
      orgId: string;
      role: string;
      effective: Record<string, boolean>;
    };
  },
};
